
import Inventory2SharpIcon from '@mui/icons-material/Inventory2Sharp';
import Diversity3SharpIcon from '@mui/icons-material/Diversity3Sharp';
import CurrencyRupeeSharpIcon from '@mui/icons-material/CurrencyRupeeSharp';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';


const ControlPanel = {
  id: '28',
  title: 'Control Panel',
  type: 'group',
  role: 'DMP_PRODUCT_MGR',
  children: [
    {
      id: 'product',
      title: 'Product',
      type: 'item',
      url: '/productpage',
      icon: QrCode2Icon
  }, 
    {
      id: 'admin-order-list',
      title: 'Order(s)',
      type: 'item',
      url: '/',
      bottomMenu:'ADMIN-ORDERS',
      icon: Inventory2SharpIcon
    },{
      id: 'credit-transfer-req',
      title: 'Credit Transfer(s)',
      type: 'item',
      url: '/',
      bottomMenu:'CREDIT-TRANSFERS',
      icon: AccountBalanceIcon
    },{
      id: 'admin-user-list',
      title: 'Business Associates',
      type: 'item',
      url: '/',
      bottomMenu:'ADMIN-USERS',
      icon: Diversity3SharpIcon
    }
    ,{
      id: 'mlmcredit',
      title: 'Credit Mgmt',
      type: 'item',
      url: '/',
      bottomMenu:'CREDIT-MGMT',
      icon: CurrencyRupeeSharpIcon
    },
    
    ,{
      id: 'payout-request',
      title: 'Payout Request',
      type: 'item',
      url: '/',
      bottomMenu:'PAYOUT-REQUEST',
      icon: AccountBalanceIcon
    }
    ,{
      id: 'kyc',
      title: 'KYC',
      type: 'item',
      url: '/',
      bottomMenu:'KYC',
      icon: SettingsAccessibilityIcon
    }
    ,{
      id: 'referrals',
      title: 'Referral(s)',
      type: 'item',
      url: '/',
      bottomMenu:'ORDER-REFERRALS',
      icon: CurrencyRupeeSharpIcon
    },
  ]
};

export default ControlPanel;